import * as React from 'react'
import styled, { css } from 'styled-components'
import ReactModal from 'react-modal'
import Icon from '../Icon/Icon'

import Loader from '../../../assets/img/loader.gif'

import media from '../../../services/generateMediaQueries'

const StyledReactModal = styled(ReactModal)`
  position: absolute;
  top: 0;
  right: 0;
  border: none;
  background: var(--color-bg-light);
  overflow: auto;
  -webkit-overflow-scrolling: touch;
  outline: none;
  width: 100%;
  max-width: 720px;
  height: 100%;
  opacity: 0;
  display: flex;
  flex-direction: column;
  transition: all var(--animation-duration) var(--animation-easing);

  &.ReactModal__Content {
    &--after-open {
      opacity: 1;
      transition: all var(--animation-duration) var(--animation-easing);
    }

    &--before-close {
      opacity: 0;
      transition: all calc(var(--animation-duration) / 2)
        var(--animation-easing);
    }
  }

  ${media.lessThan('small')`
    top: 0;
    right: 0;
    height: 100% !important;
    border-radius: 0;
    max-width: unset;
    max-height: unset;
  `}
`

const DefaultCloseButton = styled.button`
  position: absolute;
  color: var(--color-fg);
  border: 0;
  background-color: transparent;
  top: 15px;
  right: 15px;
  font-size: 30px;
  cursor: pointer;
  background: rgba(255, 255, 255, 0.5);
  width: 48px;
  height: 48px;
  padding: 9px;
  border-radius: 100%;
  outline: none;

  ${props =>
    props.zIndex &&
    css`
      z-index: ${props.zIndex + 1};
    `}

  > svg {
    vertical-align: baseline;
  }
`

const LoadingContainer = styled.div`
  min-height: 20rem;
  display: flex;
  align-items: center;
  justify-content: space-around;
`

const LoadingIcon = styled.img.attrs({ src: Loader })`
  height: 5rem;
  width: 5rem;
`

const Content = styled.div`
  padding: 70px 50px;

  ${media.lessThan('medium')`
    padding: 32px;
  `}
`

const Title = styled.h1`
  font-size: 2rem;
  line-height: 2rem;
  font-family: var(--font-family-ayala-display-sans);
  letter-spacing: var(--letter-spacing-wider);
  color: var(--color-primary);
  font-weight: var(--font-weight-boldest);
  text-transform: uppercase;
  margin: 0;
`

const Description = styled.p`
  font-size: 1.125rem;
  line-height: 1.125rem;
  letter-spacing: var(--letter-spacing-wide);
  margin-top: 1.25rem;
  margin-bottom: 3.5rem;
`

const overlay = {
  zIndex: 10000,
  background: 'rgba(0, 0, 0, 0.8)',
}

const content = {}

function CardListModal(props) {
  const {
    handleClose,
    show,
    loading,
    onClose,
    children,
    CloseButton,
    zIndex,
    shouldCloseOnOverlayClick = true,
    title,
    description,
    render = () => null,
    source = [],
    ...restProps
  } = props

  return (
    <StyledReactModal
      isOpen={show}
      style={{
        overlay: {
          ...overlay,
          ...(zIndex ? { zIndex } : {}),
        },
        content,
      }}
      onRequestClose={onClose}
      closeTimeoutMS={150}
      shouldCloseOnOverlayClick={shouldCloseOnOverlayClick}
      bodyOpenClassName="sticky-modal-open"
      htmlOpenClassName="sticky-modal-open"
      {...restProps}
    >
      <DefaultCloseButton onClick={onClose}>
        <Icon name="x" />
      </DefaultCloseButton>
      {loading ? (
        <LoadingContainer>
          <LoadingIcon />
        </LoadingContainer>
      ) : (
        <Content>
          <Title>{title}</Title>
          <Description>{description}</Description>
          {source.map(render)}
        </Content>
      )}
    </StyledReactModal>
  )
}

CardListModal.defaultProps = {}

CardListModal.propTypes = {}

export default CardListModal
